import { graphql } from 'react-relay';

export const archivePageFragment = graphql`
  fragment ArchivePage_page on ArchivePage 
  @argumentDefinitions(
    salesAdmission: { type: "String" }
  )
  {
    archive(salesAdmission: $salesAdmission) {
      ...ArchiveList_component
    }
    breadcrumbs {
      ...Breadcrumb_data
    }
    path
    id
  }
`;
